import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CompraService } from '../../../services/compra.service';
import { Compra } from '../../../models/compra';
import { ProveedorModalComponent } from '../../modals/proveedor-modal/proveedor-modal.component';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ProveedorService } from '../../../services/proveedor.service';
import { Proveedor } from '../../../models/proveedor';
//import { AsyncLocalStorage } from 'angular-async-local-storage';
import * as numeral from 'numeral';
import { Retencion } from '../../../models/retencion';
import { ParametroService } from '../../../services/parametro.service';

@Component({
	selector: 'pago-list',
	templateUrl: './pago-list.component.html',
	styleUrls: ['./pago-list.component.css'],
	providers: [CompraService, ProveedorService, ParametroService]
})
export class PagoListComponent implements OnInit, OnDestroy {
	public compras: Array<Compra>;
	public bsModalRef: BsModalRef;
	public proveedor: Proveedor;
	public loading = false;
	public numero_decimales: number;
    public format_decimal: String;

	constructor(
		public compraService: CompraService,
		private NavRoute: Router,
		private modalService: BsModalService,
		public proveedorService: ProveedorService,
		public parametroService: ParametroService,
		//private storage: AsyncLocalStorage,
	) {		
		this.compras = [];
		this.proveedor = new Proveedor();
		this.numero_decimales = 2;
        this.format_decimal = "0,0.00";
	}

	ngOnInit() {
		this.loading = true;
		this.getParamNumeroDecimales().then(
			res => this.loading = false,
			err => this.loading = false,
		);
		/*this.storage.getItem('cobroClienteSearch').subscribe(
			cliente => {
				if( cliente ){
					this.cliente = cliente;
					this.storage.getItem('cobroVentasSearch').subscribe(
						ventas => this.ventas = ventas
					);
				}
			}
		);*/
	}

	ngOnDestroy(){

		/*this.storage.removeItem('cobroClienteSearch').subscribe();
		this.storage.removeItem('cobroVentasSearch').subscribe();*/
	}

	getParamNumeroDecimales(){
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
                    this.numero_decimales = res.valor;

                    let digitos = "";
                    for(let i = 0; i < this.numero_decimales; i++) digitos += "0";

                    this.format_decimal = "0,0." + digitos
                    resolve();
                },
                err => {
                    this.numero_decimales = 2;
                    this.format_decimal = "0,0.00"
                    reject(err);
                }
            );
        });
    }

    get formatDecimal(){
        return this.format_decimal;
    }

	onSearchProveedor(event) {
		if( event.keyCode === 13 ){
			if( this.proveedor.dni.toString().trim().length == 0 ){
				this.proveedor = new Proveedor();
				this.compras = [];
				return;
			}else{
				this.proveedorService.getByDni(this.proveedor.dni).subscribe(
					res => {
						this.loading = false;
						if (res.length > 0) {
							this.proveedor = res[0];
							this.getComprasCredito(this.proveedor.id);
						}else{
							this.proveedor = new Proveedor();
							this.compras = [];
							this.openDialogProveedor();
						}
					},
					err => {
						this.loading = false;
						this.compras = [];
						this.openDialogProveedor();
					}
				);
			}
		}

		/*if (this.proveedor.dni != null && this.proveedor.dni.trim() != '')
			this.proveedorService.getByDni(this.proveedor.dni).subscribe(
				res => {
					if (res.length > 0) {
						this.proveedor = res[0];
						this.getComprasCredito(this.proveedor.id);
						//this.storage.setItem('cobroClienteSearch',this.cliente).subscribe()
					}
					else {
						this.openDialogProveedor()
					}
                },
                err => this.openDialogProveedor()
            );
		else {
			this.openDialogProveedor();
		}*/
    }

	openDialogProveedor() {
		const initialState = {pagos_pendientes: true};
		this.bsModalRef = this.modalService.show(ProveedorModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

		this.bsModalRef.content.sendProveedor.take(1).subscribe(proveedor => {
			this.proveedor = proveedor;
			//this.storage.setItem('cobroClienteSearch',this.cliente).subscribe()
			this.getComprasCredito(this.proveedor.id);
		});
	}

	getComprasCredito(proveedor_id){
		this.loading = true;
		this.compraService.getAll("?embed=tipocomprobante,retencion&tipo=CR&estado_pago=P&proveedor_id="+proveedor_id).subscribe(
			res => {
				if( res.data.length ){
					this.compras = res.data;
					this.compras.forEach((compra: Compra) => {
						if( !compra.retencion ){
							compra.retencion = new Retencion()
						}
					});
					//this.storage.setItem('cobroVentasSearch',this.ventas).subscribe()
				}else{
					this.compras = [];
				}
				this.loading = false;
			},
			err => {
				this.loading = false;
				this.compras = [];
			}
		);
	}

	onShow(id){
		this.NavRoute.navigate(['/compras/compras-show/' + id]);
	}

	onPay(id){
		this.NavRoute.navigate(['/compras/pago/' + id]);
	}
	
	numeroFactura(venta){
        return venta.serie + "-" + venta.punto_emision + "-" + venta.secuencial;
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/compras/pago-list/pago-list.component.ts